module.exports = __webpack_public_path__ + "img/DAI.2a17ad98.png";